import { ApplicationController, useDebounce } from "stimulus-use";
import { patch } from "@rails/request.js";

export default class extends ApplicationController {
  static debounces = [
    "submit",
    {
      name: "setSavedIndicator",
      wait: 500,
    },
    {
      name: "setErrorIndicator",
      wait: 500,
    }
  ];
  static targets = ["indicator"];
  static allIndicatorStyles = ["text-success", "text-primary", "text-danger"];

  connect() {
    useDebounce(this, { wait: this.autoSaveDelay });
  }

  // Public interface

  submit() {
    this.setSavingIndicator();
    patch(this.url, {
      body: this.data,
      responseKind: "json",
      signal: AbortSignal.timeout(this.autoSaveTimeout),
    })
      .then((response) => {
        if (response.ok) {
          this.setSavedIndicator();
        } else {
          this.setErrorIndicator();
        }
      })
      .catch(() => this.setErrorIndicator());
  }

  // Private methods

  setSavingIndicator() {
    this.setIndicator({
      icon: "spinner-third",
      text: "Saving...",
      style: "text-primary",
      spin: true,
    });
  }

  setSavedIndicator() {
    this.setIndicator({ icon: "check", text: "Saved", style: "text-success" });
  }

  setErrorIndicator() {
    this.setIndicator({
      icon: "triangle-exclamation",
      text: "Failed to save - please try again",
      style: "text-danger",
    });
  }

  setIndicator({ icon, text, style = null, spin = false }) {
    if (!this.hasIndicatorTarget) {
      return;
    }

    this.indicatorTarget.classList.remove(
      ...this.constructor.allIndicatorStyles
    );
    this.indicatorTarget.classList.add(style);
    this.indicatorTarget.replaceChildren(
      this.createIndicator({ icon: icon, spin: spin }),
      text
    );
  }

  createIndicator({ icon, spin = true }) {
    const indicator = document.createElement("i");
    let classes = `fa-solid fa-fw fa-${icon}`;
    if (spin) {
      classes += " fa-spin";
    }
    indicator.setAttribute("class", classes);

    return indicator;
  }

  get url() {
    return this.element.getAttribute("action");
  }

  get data() {
    return new FormData(this.element);
  }

  get autoSaveDelay() {
    return parseInt(this.metaValue("auto-save-delay")) || 500;
  }

  get autoSaveTimeout() {
    return parseInt(this.metaValue("auto-save-timeout")) || 10_000;
  }
}
